import debounce from 'debounce';

export default {
  data() {
    return {
      searchTerm: '',
    };
  },

  create(searchCallback, delay = 300) {
    const debouncedSearch = debounce((value) => {
      searchCallback(value);
    }, delay);

    return {
      updateSearch: (value) => {
        const trimmedValue = value?.trim() || '';
        debouncedSearch(trimmedValue);
        return trimmedValue;
      },
    };
  },
};
